/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateBriefFromProductCardMutationVariables = Types.Exact<{
    slug: Types.Scalars['String'];
    fields: Types.Scalars['Map'];
    designerIds?: Types.Maybe<Array<Types.Scalars['Int']> | Types.Scalars['Int']>;
}>;

export type CreateBriefFromProductCardMutation = {
    __typename: 'Mutation';
    brief: { __typename: 'StructuredBrief'; id: string };
};

export const CreateBriefFromProductCardDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateBriefFromProductCard' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'fields' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Map' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'designerIds' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'brief' },
                        name: { kind: 'Name', value: 'createBriefWithSlug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'slug' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'fields' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'fields' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'designerIds' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'designerIds' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export type CreateBriefFromProductCardMutationFn = Apollo.MutationFunction<
    CreateBriefFromProductCardMutation,
    CreateBriefFromProductCardMutationVariables
>;
export type CreateBriefFromProductCardComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CreateBriefFromProductCardMutation,
        CreateBriefFromProductCardMutationVariables
    >,
    'mutation'
>;

export const CreateBriefFromProductCardComponent = (
    props: CreateBriefFromProductCardComponentProps
) => (
    <ApolloReactComponents.Mutation<
        CreateBriefFromProductCardMutation,
        CreateBriefFromProductCardMutationVariables
    >
        mutation={CreateBriefFromProductCardDocument}
        {...props}
    />
);

/**
 * __useCreateBriefFromProductCardMutation__
 *
 * To run a mutation, you first call `useCreateBriefFromProductCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBriefFromProductCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBriefFromProductCardMutation, { data, loading, error }] = useCreateBriefFromProductCardMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      fields: // value for 'fields'
 *      designerIds: // value for 'designerIds'
 *   },
 * });
 */
export function useCreateBriefFromProductCardMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateBriefFromProductCardMutation,
        CreateBriefFromProductCardMutationVariables
    >
) {
    return Apollo.useMutation<
        CreateBriefFromProductCardMutation,
        CreateBriefFromProductCardMutationVariables
    >(CreateBriefFromProductCardDocument, baseOptions);
}
export type CreateBriefFromProductCardMutationHookResult = ReturnType<
    typeof useCreateBriefFromProductCardMutation
>;
export type CreateBriefFromProductCardMutationResult =
    Apollo.MutationResult<CreateBriefFromProductCardMutation>;
export type CreateBriefFromProductCardMutationOptions = Apollo.BaseMutationOptions<
    CreateBriefFromProductCardMutation,
    CreateBriefFromProductCardMutationVariables
>;
